import { z } from 'zod';

/**
 * Zod schema for a valid Ethereum address (0x-prefixed, 42 chars).
 * Infers as `0x${string}` for type compatibility with viem.
 */
export const ethereumAddressSchema = z
  .string()
  .regex(/^0x[a-fA-F0-9]{40}$/)
  .transform((val) => val as `0x${string}`);

/**
 * Zod schema for a valid keccak-256 hash (0x-prefixed, 66 chars).
 * Infers as `0x${string}` for type compatibility with viem.
 */
export const keccakHashSchema = z
  .string()
  .regex(/^0x[a-fA-F0-9]{64}$/)
  .transform((val) => val as `0x${string}`);
